@if (model()) {
  <app-address-form
    [resource]="model()!"
    [type]="'location'"
    (formGroupOutput)="formGroup = $event"
    [showNameField]="true"
    [showActiveStatus]="false"/>

  @if (formGroup) {
    <div class="d-flex justify-content-end align-items-center mt-4">
      <app-mdb-button (onClick)="submit()" [text]="'SAVE'" [loading]="loading" />
    </div>
  }
}

@if (!model()) {
  <app-spinner />
}
